// extracted by mini-css-extract-plugin
module.exports = {"container":"login_container__6x_TJ","wrapper":"login_wrapper__Fo4_h","github":"login_github__k55Sc"};